import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popupActions } from '../../store/popupStore';
import { reportActions } from '../../store/reportStore';
import { Translate } from 'react-localize-redux';
import AmlGlobalEval from './aml/amlGlobalEval';
import AmlReportStatus from './aml/amlReportStatus';
import AmlRelatedSubjectsEval from './aml/amlRelatedSubjectsEval';
import ExcelExportButton from "../common/excelExportButton";
import SvgRefresh from "../../img/icons/Refresh";
import { AmlExplanatoryNotes2 } from '../reportSections/aml/amlExplanatoryNotes';
import AmlReportDateInformation from "../search/aml/amlReportDateInformation";

import './aml/aml.scss';

class AmlInfoCheck extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent = (data) => {
        return (
            <AmlReportStatus
                data={this.props.data}
                dataHash={this.props.dataHash}
                onNotRequested={() => this.props.postSectionRequest([this.props.sectionId])}
                onInProgress={() => this.props.requestFetchSection([this.props.sectionId])}
            >
                <div className="aml-available">
                    <div className="columns">
                        <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                            <SvgRefresh className="refresh-icon" />
                            <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.props.showPopup('updateAmlData', {
                                open: true,
                                close: () => this.props.hidePopup(),
                                onSubmitAmlRequest: () => this.props.postSectionRequest([this.props.sectionId]),
                                data: this.props.data,
                                asCompany: true
                            })}
                            >
                                <Translate id="Report.Aml.UpdateData" />
                            </div>
                        </div>
                        <div className='column'>
                            <AmlReportDateInformation inserted={this.props.data.insertedFormated} completed={this.props.data.completedFormated} profile={this.props.data.amlProfileName} />
                        </div>
                    </div>
                    <div className="columns is-centered">
                        <div className="column is-12">
                            <AmlGlobalEval data={data} decision={data.decision} inserted={data.inserted} completed={data.completed} />
                            <AmlRelatedSubjectsEval finalOwnerNegativeInfoText={data.finalOwnerNegativeInfoText} subjects={data.subjects} profiles={data.amlRelationProfiles} methodology={data.methodology} share={data.share} hideRatioFilter={false} />
                            <AmlExplanatoryNotes2 data={data} />
                        </div>
                    </div>
                    <ExcelExportButton link="aml-info-check" entityId={this.props.id} report={this.props.reportType} />
                </div>
            </AmlReportStatus>
        )
    }
}

export default connect(
    state => ({}),
    dispatch => bindActionCreators(Object.assign({}, reportActions, popupActions), dispatch)
)(AmlInfoCheck);